import * as types from "./actionTypes"

export function fetchEmailNotifications() {
    return {
        type: types.EMAIL_NOTIFICATION_FETCH_DATA,
    }
}

export function fetchEmailNotificationsSuccess(data) {
    return {
        type: types.EMAIL_NOTIFICATION_SUCCESS,
        payload: data,
    }
}

export function fetchEmailNotificationsFailure() {
    return {
        type: types.EMAIL_NOTIFICATION_FAILURE,
    }
}

export function createNewEmails(emails) {
    return {
        type: types.CREATE_NEW_EMAILS,
        payload: emails,
    }
}

export function createNewEmailsSuccess() {
    return {
        type: types.CREATE_NEW_EMAILS_SUCCESS,
    }
}

export function createNewEmailsFailure() {
    return {
        type: types.CREATE_NEW_EMAILS_FAILURE,
    }
}

export function updateEmails(emails, configId) {
    return {
        type: types.UPDATE_EMAILS,
        payload: {emails, configId},
    }
}

export function updateEmailsSuccess() {
    return {
        type: types.UPDATE_EMAILS_SUCCESS,
    }
}
export function updateeNewEmailsFailure() {
    return {
        type: types.UPDATE_EMAILS_FAILURE,
    }
}

export function resetEmailnotificationSave() {
    return {
        type: types.EMAIL_NOTIFICATION_RESET_SAVE,
    }
}
